export default __webpack_public_path__ + "0cdf1e5be1e3292b1ef967c39f45462a.png";